/**
 * pollAdapterRegistry - Maps tab modes to their polling adapter.
 *
 * Tab hooks register a polling function that normalizes their
 * backend status response into a `PollUpdate`. GenerationContext uses
 * the registry to resume polling for persisted jobs after a page reload,
 * without the originating tab component needing to remount first.
 */

import type { GenerationTabMode, PollAdapter } from '../../types/generationJob';

const registry = new Map<GenerationTabMode, PollAdapter>();

export function registerPollAdapter(tab: GenerationTabMode, adapter: PollAdapter): void {
  registry.set(tab, adapter);
}

export function getPollAdapter(tab: GenerationTabMode): PollAdapter | undefined {
  return registry.get(tab);
}

export function hasPollAdapter(tab: GenerationTabMode): boolean {
  return registry.has(tab);
}
